import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const forWho = ['Mujeres mayores de 50 años que sufren de hinchazón abdominal persistente.', 'Aquellas que sienten fatiga crónica incluso después de dormir "bien".', 'Mujeres que notan que su ropa ya no les queda igual debido a la inflamación.', 'Personas que buscan un método natural basado en la biología femenina hispana.'];
const notForWho = ['Personas que buscan "soluciones mágicas" sin cambiar un solo hábito.', 'Atletas de alto rendimiento o personas que buscan hipertrofia muscular.', 'Menores de 40 años que aún no han experimentado cambios hormonales significativos.'];
export function WhoIsItFor() {
  return <section className="py-20 px-6 bg-white" data-id="element-131">
      <div className="max-w-6xl mx-auto" data-id="element-132">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-133">
          {/* Es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-cream/50 p-8 rounded-3xl border border-brand-green/20" data-id="element-134">
            <h3 className="text-2xl font-bold mb-8 text-brand-green flex items-center gap-3" data-id="element-135">
              <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-136" />
              Es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-137">
              {forWho.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-138">
                  <div className="mt-1.5 w-2 h-2 rounded-full bg-brand-green flex-shrink-0" data-id="element-139"></div>
                  <p className="text-gray-700 leading-relaxed" data-id="element-140">{text}</p>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50/50 p-8 rounded-3xl border border-red-100" data-id="element-141">
            <h3 className="text-2xl font-bold mb-8 text-gray-800 flex items-center gap-3" data-id="element-142">
              <XCircle className="w-8 h-8 text-red-500" data-id="element-143" />
              No es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-144">
              {notForWho.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-145">
                  <div className="mt-1.5 w-2 h-2 rounded-full bg-red-400 flex-shrink-0" data-id="element-146"></div>
                  <p className="text-gray-700 leading-relaxed" data-id="element-147">{text}</p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}